<script setup lang="ts">
import { onBeforeUnmount, onMounted } from 'vue';
import './equipment-ui.css';

const props = withDefaults(defineProps<{ title: string; wide?: boolean }>(), {
  wide: false,
});
const emit = defineEmits<{ close: [] }>();

const onKey = (event: KeyboardEvent) => {
  if (event.key === 'Escape') emit('close');
};
onMounted(() => window.addEventListener('keydown', onKey));
onBeforeUnmount(() => window.removeEventListener('keydown', onKey));
</script>

<template>
  <Teleport to="body">
    <div class="eqm" @mousedown.self="emit('close')">
      <section
        class="eqm__panel eq-card"
        :class="{ 'eqm__panel--wide': props.wide }"
        role="dialog"
        aria-modal="true"
        :aria-label="title"
      >
        <header class="eqm__head">
          <h2 class="eqm__title">{{ title }}</h2>
          <button
            type="button"
            class="eq-btn eq-btn--icon"
            aria-label="Fermer"
            @click="emit('close')"
          >
            <i class="pi pi-times" />
          </button>
        </header>
        <div class="eqm__body"><slot /></div>
        <footer v-if="$slots.footer" class="eqm__foot">
          <slot name="footer" />
        </footer>
      </section>
    </div>
  </Teleport>
</template>

<style scoped>
.eqm {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(0, 0, 0, 0.45);
}
.eqm__panel {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 32rem;
  max-height: calc(100vh - 2rem);
}
.eqm__panel--wide {
  max-width: 44rem;
}
.eqm__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.25rem 1.5rem 0.75rem;
}
.eqm__title {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 800;
  color: var(--nxt-on-surface);
}
.eqm__body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0.5rem 1.5rem 1rem;
  overflow-y: auto;
}
.eqm__foot {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1rem 1.5rem 1.25rem;
  border-top: 1px solid var(--nxt-outline-variant);
}
</style>
